import { FormattedMessage } from 'react-intl';
import React from 'react';
import { NavSteps } from '../../hooks/useSyncFlowNav';

const CalSelectDialogContinueButtonStrings = {
  continueButton: <FormattedMessage id="calendar.sync_flow.dialog.button_continue" defaultMessage="Continue"/>
};

export const ButtonTextMap = {
  [NavSteps.SELECT_CALENDAR]: <FormattedMessage id="calendar.sync_flow.dialog.button_sync" defaultMessage="Sync calendar"/>,
  [NavSteps.I_CALENDAR]: <FormattedMessage id="calendar.sync_flow.dialog.button_done" defaultMessage="Done"/>
};

export default CalSelectDialogContinueButtonStrings;
